export const processedMarketingAttributionReduxConstants = {
  GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA:
    "GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA",
  GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA:
    "GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA",
};

export const processedChartStyleOptions = {
  legend: { position: "none" },
  colors: ["#027b68", "#0b0f36"],
  backgroundColor: "#fff",
  bar: { width: "20%" },
  hAxis: {
    title: "Days After Marketing",
    titleTextStyle: {
      color: "#444",
      fontName: "montserrat",
      fontSize: 13,
      italic: false,
    },
    viewWindow: {
      min: 0,
    },
    format: "0",
  },
  vAxis: {
    title: "Number of Orders",
    titleTextStyle: {
      color: "#444",
      fontName: "montserrat",
      fontSize: 13,
      italic: false,
    },
    format: "0",
  },
};
export const processedReportGraphHeaders = {
  DAYS_AFTER_MARKETING: "Days After Marketing",
  TOTAL_ORDERS: "Total Orders",
};

export const processedMessageType = {
  3: "Email",
  4: "SMS",
};
